import { render, staticRenderFns } from "./selfcheck.vue?vue&type=template&id=0ce07265&scoped=true&"
import script from "./selfcheck.vue?vue&type=script&lang=js&"
export * from "./selfcheck.vue?vue&type=script&lang=js&"
import style0 from "./selfcheck.vue?vue&type=style&index=0&id=0ce07265&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce07265",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce07265')) {
      api.createRecord('0ce07265', component.options)
    } else {
      api.reload('0ce07265', component.options)
    }
    module.hot.accept("./selfcheck.vue?vue&type=template&id=0ce07265&scoped=true&", function () {
      api.rerender('0ce07265', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/selfcheck.vue"
export default component.exports